import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SmartGridFeatureValues } from '@vi-iot/client/index';

@Pipe({
  name: 'dryContactSgReadyInfo',
  standalone: true,
})
export class DryContactSgReadyInfoPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string): string {
    switch (value) {
      case SmartGridFeatureValues.normalOperation:
        return this.translateService.instant(
          '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.SG_NORMAL_TOOLTIP'
        );
      case SmartGridFeatureValues.recommendedOperation:
        return this.translateService.instant(
          '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.SG_RECOMMENDED_TOOLTIP'
        );
      case SmartGridFeatureValues.forcedOperation:
        return this.translateService.instant(
          '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.SG_FORCED_TOOLTIP'
        );
      case SmartGridFeatureValues.off:
        return this.translateService.instant(
          '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.SG_OFF_TOOLTIP'
        );
      default:
        return '';
    }
  }
}
